import React from "react"
import { IoIosCheckmarkCircleOutline } from "react-icons/io"

interface IProps {
  text: string
}

const CheckMark = (props: IProps) => {
  const { text } = props
  return (
    <div className="mb-4 w-full md:w-4/12">
      <p className="flex ">
        <IoIosCheckmarkCircleOutline height="50px" className="m-1" />
        {text}
      </p>
    </div>
  )
}

export default CheckMark
